var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplayChartUpSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 42,
    viewBox: "0 0 47 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7607_8600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.25C0 2.3543 2.34184 0 5.22222 0H41.7778C44.6582 0 47 2.3543 47 5.25V28.875C47 31.7707 44.6582 34.125 41.7778 34.125H27.4167L28.2898 36.75H33.9444C35.3887 36.75 36.5556 37.923 36.5556 39.375C36.5556 40.827 35.3887 42 33.9444 42H13.0556C11.6113 42 10.4444 40.827 10.4444 39.375C10.4444 37.923 11.6113 36.75 13.0556 36.75H18.7102L19.5833 34.125H5.22222C2.34184 34.125 0 31.7707 0 28.875V5.25ZM5.22222 5.25V28.875H41.7778V5.25H5.22222ZM30.6806 7.875H37.2083C38.2936 7.875 39.1667 8.75273 39.1667 9.84375V16.4062C39.1667 17.4973 38.2936 18.375 37.2083 18.375C36.1231 18.375 35.25 17.4973 35.25 16.4062V14.5934L26.1927 23.707C25.8255 24.0762 25.3278 24.2812 24.8056 24.2812C24.2833 24.2812 23.7856 24.0762 23.4184 23.707L18.2778 18.5391L11.1788 25.6758C10.4118 26.4469 9.17153 26.4469 8.41267 25.6758C7.65382 24.9047 7.64566 23.6578 8.41267 22.8949L16.8906 14.3555C17.6576 13.5844 18.8979 13.5844 19.6568 14.3555L24.7974 19.5234L32.4839 11.8125H30.6806C29.5953 11.8125 28.7222 10.9348 28.7222 9.84375C28.7222 8.75273 29.5953 7.875 30.6806 7.875Z",
    fill: "#EA8254"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7607_8600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayChartUpSolid);
export default __webpack_public_path__ + "static/media/display-chart-up-solid.7961e97a3fda86d3bf034744022d1994.svg";
export { ForwardRef as ReactComponent };